var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-view-info-container"},[_vm._t("default"),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"data-loader"},[_c('img',{attrs:{"src":require("../../../static/img/white-loader.svg")}})]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e72b59e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/global-view-info-container.vue
// module id = FWyX
// module chunks = 1